export function genAIConsent(userStatus: any): boolean {
  return (
    window.env?.SHOW_GEN_AI &&
    !getGenAIConsent(userStatus) &&
    hasAllAccess(userStatus) &&
    !isGenAIRole(userStatus) &&
    isGenAIBetaDate()
  );
}

function isGenAIBetaDate() {
  const from = new Date(window.env.GEN_AI_BETA_DATE_START);
  const to = new Date(window.env.GEN_AI_BETA_DATE_END);
  const todayUTC = new Date().toISOString();
  return new Date(todayUTC) >= from && new Date(todayUTC) <= to;
}

function hasAllAccess(userStatus: any): boolean {
  return (
    userStatus?.bundles?.entitlements?.some(
      (entitlement: any) =>
        entitlement?.product_id == window.env.APPROVED_AI_ENTITLEMENTS
    ) ?? false
  );
}

function isCiscoEmployee(userStatus: any) {
  if (typeof userStatus?.email !== "string") return false;

  const email = userStatus?.email?.trim().toLowerCase();
  if (!email || !email.includes("@")) return false;

  const [, domain] = email.split("@");
  return domain === "cisco.com";
}

function getGenAIConsent(userStatus: any): boolean {
  return userStatus?.genAIConsent ?? false;
}

function isGenAIRole(userStatus: any): boolean {
  return (
    userStatus?.["user-roles"]?.some(
      (role: any) => role?.roleId == window.env.APPROVED_AI_ROLE_ID
    ) ?? false
  );
}
